import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'

import { ReactComponent as DisposalFeeIcon } from 'assets/DisposalFee.svg'
import HHDisplayMoney from 'components/common/HHDisplayMoney'
import StyledBadge from 'components/notes/common/StyledBadge'
import DisposalTicketPopoverV2 from 'components/work-order/disposal-ticket-listing/DisposalTicketPopoverV2'
import { formatCentsToDollars } from 'utils/price'

const DisposalTicketBadge = ({
  totalCents = 0,
  workOrderId,
  configuredServiceId,
  hasDisposalTicket = false,
  onOpenDisposalTicketDialog = noop,
}) => {
  const [viewPopoverAnchorEl, setViewPopoverAnchorEl] = useState(null)

  const handleViewPopoverOpen = event => {
    event.stopPropagation()
    setViewPopoverAnchorEl(event.currentTarget)
  }

  const handleViewPopoverClose = useCallback(() => setViewPopoverAnchorEl(null), [])

  const total = formatCentsToDollars(totalCents)
  const hasDecimal = !Number.isInteger(totalCents)

  return (
    <>
      <Tooltip arrow disableInteractive disableHoverListener={hasDisposalTicket} placement="bottom" title="Disposal ticket">
        <IconButton
          size="small"
          onClick={onOpenDisposalTicketDialog}
          {...(hasDisposalTicket && {
            onMouseEnter: handleViewPopoverOpen,
            onMouseLeave: handleViewPopoverClose,
          })}
        >
          <StyledBadge
            badgeContent={hasDisposalTicket ? <HHDisplayMoney fixedDecimalScale={hasDecimal} formatToDollars={false} value={total} /> : 0}
          >
            <DisposalFeeIcon />
          </StyledBadge>
        </IconButton>
      </Tooltip>
      <DisposalTicketPopoverV2
        anchorEl={viewPopoverAnchorEl}
        configuredServiceId={configuredServiceId}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        workOrderId={workOrderId}
        onClose={handleViewPopoverClose}
      />
    </>
  )
}

DisposalTicketBadge.propTypes = {
  totalCents: PropTypes.number,
  workOrderId: PropTypes.string.isRequired,
  configuredServiceId: PropTypes.string.isRequired,
  hasDisposalTicket: PropTypes.bool,
  onOpenDisposalTicketDialog: PropTypes.func,
}

export default DisposalTicketBadge
